import Axios from "axios";

export function getPoaUploadConfig(formSchema, fieldName) {
  const poaConfig = formSchema?._poa;

  if (!fieldName) {
    return null;
  }

  if (!poaConfig) {
    return fieldName.includes("_poa") ? { name: fieldName } : null;
  }

  if (poaConfig.name) {
    return poaConfig.name === fieldName ? poaConfig : null;
  }

  return fieldName.includes("_poa") ? poaConfig : null;
}

export async function validatePoaUpload({
  files,
  fieldName,
  formSchema,
  responseId,
  onboardingId,
  serverUrl,
}) {
  const poaConfig = getPoaUploadConfig(formSchema, fieldName);

  if (!poaConfig) {
    return { valid: true };
  }

  for (const file of files || []) {
    const poaCheckData = new FormData();
    poaCheckData.append("file", file);
    poaCheckData.append("field_name", fieldName);

    if (responseId) {
      poaCheckData.append("response_id", responseId);
    }

    if (onboardingId) {
      poaCheckData.append("onboarding_id", onboardingId);
    }

    if (poaConfig.issued_within_months !== undefined && poaConfig.issued_within_months !== null) {
      poaCheckData.append("issued_within_months", poaConfig.issued_within_months);
    }

    try {
      const checkResult = await Axios.post(
        serverUrl + "/api/public/poa-check",
        poaCheckData
      );

      if (!checkResult.data || !checkResult.data.valid) {
        return {
          valid: false,
          message:
            checkResult.data?.reason ||
            "The uploaded file does not appear to be a valid proof of address document. Please upload a legitimate document.",
        };
      }
    } catch (err) {
      const message =
        err.response?.status === 429
          ? "Too many document checks. Please wait a few minutes before trying again."
          : "Document validation failed. Please try again or contact support.";
      return { valid: false, message };
    }
  }

  return { valid: true };
}
